import React from 'react';

import type { MessageDescriptor } from 'react-intl';

import { templateGalleryMessages } from '@atlaskit/editor-common/messages';
import type { QuickInsertItem } from '@atlaskit/editor-common/provider-factory';
import TemplateIcon from '@atlaskit/icon-lab/core/template';

import { openTemplateGallerySafely } from '../../utils/openTemplateGallery';

import { getSnippetQuickInsertKeywords } from './utils';

type Intl = {
	formatMessage: (
		descriptor: MessageDescriptor,
		values?: Record<string, string | number | boolean | Date>,
	) => string;
};

export const getTemplateGalleryQuickInsertItem = (
	openTemplateGallery: () => void,
	intl?: Intl,
): QuickInsertItem => ({
	key: 'block-template',
	title:
		intl?.formatMessage(templateGalleryMessages.templateGalleryTitle) ?? 'Block Template Gallery',
	description:
		intl?.formatMessage(templateGalleryMessages.templateGalleryDescription) ??
		'Create, discover, & insert block templates',
	keywords: getSnippetQuickInsertKeywords(intl),
	isDisabledOffline: true,
	icon: () => <TemplateIcon label="Block template icon" />,
	action: (_insert, state) => {
		openTemplateGallerySafely(openTemplateGallery);

		return state.tr;
	},
});
